import { reaction, action, observable, computed, flow, toJS } from 'mobx';

import orderBy from 'lodash/orderBy';

import api from '../services/api';

import intlStore from './intl';
import userStore from './user';
import analyticsStore from './analytics';

class Ranking {
    constructor() {
        this.fetch();
        reaction(
            () => this._country,
            () => this.fetchRanking(),
        )
    }

    @observable
    _countries = [];

    @observable
    _country = 0;
    
    @observable
    _ranking = {};

    @computed
    get country() {
        const country = this._country;
        const countries = this.countries;
        return countries.find((c) => c.id === country);
    }

    @computed
    get countries() {
        return this._decorateCountries(this._countries);
    }

    @computed
    get ranking() {
        return this._decorateRanking(this._ranking);
    }

    @action
    setCountry(country) {
        this._country = country;
    }

    fetch = async () => {
        await this.fetchCountries();
        await userStore.fetchDB()
        // this.fetchRanking();
    }    
    
    score = flow(function*(score) {
        try {
            yield api.Common.score(score);

            analyticsStore.event({
                category: 'Social Share',
                action: 'Register score',
                value: score,
            }); 
        
        } catch (e) {
            this.error = e.message;
        } finally {            this.loading = false;
        }
    });
    
    fetchRanking = flow(function*() {
        try {
            const country = this._country;

            const { score } = userStore;
        
            const response = yield api.Common.ranking(country, score);

            this._ranking = Object.assign(response, {
                ranking: response.ranking.map((entry, index) => Object.assign(entry, {index}))
            });

        } catch (e) {
            this.error = e.message;
        } finally {
            this.loading = false;
        }
    });

    fetchCountries = flow(function*() {
        try {
            this._countries = yield api.Common.country();
        } catch (e) {
            this.error = e.message;
        } finally {
            this.loading = false;
        }
    })

    _decorateRanking(content) {
        const { dictionary } = intlStore;
        let ranking = toJS(content.ranking) || [];
        let position = content.position;

        const { _user: user, _country: user_country, score: user_score } = userStore;

        let howMany = ranking.filter((entry) => 
            +entry.position === position && entry.name !== '???'
        );

        let hasMe = !!howMany.some((entry) => 
            entry.name === user && 
            +entry.country_id === +user_country && 
            +entry.position === position
        );
        
        if (!hasMe) {
            let lastEntry = ranking[ranking.length-1];
            if (howMany.length > 1) {
                let toReplace = howMany[0]['index'];
                ranking[toReplace]['name'] = '???';
            }
            else if (howMany.length === 1 && howMany[0]['score'] === user_score) {
                let toReplace = howMany[0]['index'];
                ranking[toReplace]['name'] = '???';
            }
            else if (lastEntry && (position > lastEntry['position'] && lastEntry['name'] !== '???')) {
                ranking.push({ name: '???' });
            }
            else if (lastEntry && !position && (user_country === this._country || this._country === 0)) {
                position = lastEntry['position'] + 1;
                ranking.push({ name: '???' });
            }
        }
            
    
        ranking = ranking.map((entry, index) => {

            if (entry.name === '???' || entry.position === position) {
                entry = Object.assign(entry, {
                    position: position,
                    name: user,
                    country_id: user_country || "0",
                    score: user_score,
                    me: true,
                    hide: +user_country !== +this._country && +this._country,
                })
            };

            const country = this._countries.find((country => entry.country_id === country.id)) || {};

            return Object.assign(entry, { 
                country: dictionary[`LOCALE.IOC.${country.ioc}`], 
            });
        });

        return orderBy(ranking, ['position'], ['asc']);
    }

    _decorateCountries(content) {
        content = content.map((entry) => ({
            id: entry.id,
            label: entry.ioc,
        }));

        return orderBy(content, ['id'], ['asc']);
    }
}

export default new Ranking();
